import { z } from 'zod';
import { DynamicBaseDTO } from './DynamicBaseDTO';

export const DynamicLabelDTO = DynamicBaseDTO.extend({
    text: z.string(),
    url: z.string(),
    iconName: z.string().optional(),
});

export type DynamicLabelDTO = z.infer<typeof DynamicLabelDTO>;
